import React, { useEffect } from 'react';
import { Alert } from 'react-native';
import { setSessionExpiredHandler } from '../shared/auth';
import AppNavigator from '../navigation/AppNavigator';
import { setupReminderForegroundListener } from '../data/domains/dashboard';
import { useTranslation } from '../shared/i18n';

/** Auth/theme already resolved in App bootstrap; gate only installs listeners. */
export function AppInitializerGate() {
  const { t } = useTranslation();

  useEffect(() => {
    setSessionExpiredHandler(() => {
      Alert.alert(t('auth.sessionExpired'), t('auth.sessionExpiredMessage'));
    });
    return () => setSessionExpiredHandler(null);
  }, [t]);

  useEffect(() => {
    const unsubscribe = setupReminderForegroundListener();
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  return <AppNavigator />;
}
